// extracted by mini-css-extract-plugin
export default {"wrapper":"Partners_wrapper__+bEJY","item":"Partners_item__8GQ8q","AU":"Partners_AU__mrZ2+","PFL":"Partners_PFL__nmaWO","RIT":"Partners_RIT__iND-X","FUGAS":"Partners_FUGAS__TzFS8"};